import { render } from "./CourseDetails.vue?vue&type=template&id=48a9325a&ts=true"
import script from "./CourseDetails.vue?vue&type=script&lang=ts"
export * from "./CourseDetails.vue?vue&type=script&lang=ts"

import "./CourseDetails.vue?vue&type=style&index=0&id=48a9325a&lang=css"

import exportComponent from "/Users/uchidakouhei/workspace/docker/new-mentalnc-docker/src/new-well-labo.members.mentalnc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__